<template>
    <x-page title="Department Report">

        <template #header-actions>
            <x-back-button :disabled="isLoading" 
                :display-warning="false"
                :click-handler="router => router.replace('/admin/reports')" />
        </template>

        <x-filter-box :onFilter="handleFilter"
            :onReset="resetFilter"
            submit-label="Download"
            submit-icon="file-excel-o"
            :open="true"
            :help-text="null"
            title="Department Report">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Dari Tanggal"
                        :error="getError('with_count_gathering_from')">
                        <input id="with_count_gathering_from"
                            type="date"
                            class="form-control"
                            v-model="filters.with_count_gathering_from" />
                    </x-form-group>
                </div>
				<div class="col-xs-12 col-md-6">
                    <x-form-group label="Sampai Tanggal"
                        :error="getError('with_count_gathering_to')">
                        <input id="with_count_gathering_to"
                            type="date"
                            class="form-control"
                            v-model="filters.with_count_gathering_to" />
                    </x-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Group Sheet By"
                        :error="getError('sheet_category_id')">
                        <x-ajax-dropdown url="/api/group-categories"
                            label="label"
                            v-model="sheetCategory"
                            :blacklist="sheetCategoryBlacklist"
                            class="form-control"
                            placeholder="Ketik label kategori" />
                    </x-form-group>
                </div>
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Absen By"
                        :error="getError('attendance_category_id')">
                        <x-ajax-dropdown url="/api/group-categories"
                            label="label"
                            v-model="attendanceCategory"
                            :blacklist="attendanceCategoryBlacklist"
                            class="form-control"
                            placeholder="Ketik label kategori" />
                    </x-form-group>
                </div>
            </div>

        </x-filter-box>
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../../components/XAjaxDropdown.vue'
import XBackButton from '../../../components/XBackButton.vue'
import XFilterBox from '../../../components/XFilterBox.vue'
import XFormGroup from '../../../components/XFormGroup.vue'
import XPage from '../../../components/XPage.vue'
import { dateFormat } from '../../../constants'
import FilterableMixin from '../../../mixins/FilterableMixin'
import FormErrorMixin from '../../../mixins/FormErrorMixin'

const defaultFilters = {
    attendance_category_id: null,
    sheet_category_id: null,
    with_count_gathering_from: moment().clone().startOf('month').format(dateFormat),
    with_count_gathering_to: moment().clone().endOf('month').format(dateFormat),
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XPage,
        XBackButton,
        XFilterBox,
        XFormGroup,
        XAjaxDropdown,
    },
    created() {
        this.preselectFilters(defaultFilters)
    },
    data() {
        return {
            attendanceCategory: null,
            errors: {},
            filters: { ...defaultFilters },
            sheetCategory: null,
        }
    },
    methods: {
        handleFilter() {
            let hasErrors = false
            this.errors = {}

            for (let key in this.filters) {
                if (!Boolean(this.filters[key])) {
                    this.errors[key] = 'Kolom ini harus diisi'
                    hasErrors = true
                }
            }

            if (hasErrors) {
                return
            }

            window.open(`/admin/reports/attendance-overview/excel-export?${$.param(this.filters)}`)
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.errors = {}
        },
    },
    mixins: [
        FilterableMixin,
        FormErrorMixin,
    ],
    watch: {
        'filters.attendance_category_id': {
            handler(id) {
                this.syncFilterToProperty(id, 'attendanceCategory', `/api/group-categories/${id}`)
            },
            immediate: true,
        },
        'filters.sheet_category_id': {
            handler(id) {
                this.syncFilterToProperty(id, 'sheetCategory', `/api/group-categories/${id}`)
            },
            immediate: true,
        },
        attendanceCategory: {
            handler(resource) {
                this.syncPropertyToFilter(resource, 'attendance_category_id')
            },
            deep: true,
        },
        sheetCategory: {
            handler(resource) {
                this.syncPropertyToFilter(resource, 'sheet_category_id')
            },
            deep: true,
        },
    }
}
</script>